module.exports = __webpack_public_path__ + "static/media/friendfinderTextImage.7ac2e60b.png";